import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';
import { get } from 'lodash';
import UploadButton from '../atoms/UploadButton';
import ClearButton from '../atoms/ClearButton';

const styles = theme => ({
  inputLabel: {
    display: 'inline !important'
  },
  input: {
    display: 'none'
  },
  image: {
    width: '300px',
    margin: '5px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      margin: '5px 0'
    }
  }
});

const enhance = compose();

const Main = enhance(
  ({
    classes,
    label,
    setFile,
    previewImage,
    setPreviewImage,
    isOnlyImage = false
  }) => {
    const imagePreview = preview => {
      const reader = new FileReader();
      reader.readAsDataURL(preview);
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
    };

    const handleOnChange = e => {
      const newFile = e.target.files[0];
      if (isOnlyImage) {
        const mineFile = get(newFile, 'type', '');
        if (mineFile.search('image/') >= 0) {
          setFile(newFile);
          imagePreview(newFile);
        } else {
          alert('画像の形式が正しくありま線。');
        }
      } else {
        setFile(newFile);
        imagePreview(newFile);
      }
      e.target.value = null;
    };

    return (
      <div>
        <InputLabel
          htmlFor={label}
          margin="dense"
          className={classes.inputLabel}
        >
          <UploadButton />
          <ClearButton
            onClickAction={() => {
              setFile(null);
              setPreviewImage(null);
            }}
          />
        </InputLabel>
        {previewImage && (
          <Card className={classes.image}>
            <CardActionArea>
              <CardMedia component="img" image={previewImage} />
            </CardActionArea>
          </Card>
        )}

        <input
          id={label}
          type="file"
          accept="image/*"
          className={classes.input}
          onChange={e => handleOnChange(e)}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
